import { router } from "@inertiajs/vue3"

router.on("navigate", () => {
  // save previous page url in session storage
  const currentUrl = window.location.href
  const storedCurrent = sessionStorage.getItem("current_page")

  if (storedCurrent !== currentUrl) {
    sessionStorage.setItem("previous_page", storedCurrent || document.referrer)
  }
  sessionStorage.setItem("current_page", currentUrl)
})
